import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "../CommonStyles/commonformstyles.module.scss";
import { MdNavigateNext } from "react-icons/md";
import ServiceDetailsForm from "./ServiceDetailsForm";
import ServicePackageForm from "./ServicePackageForm";
import ServiceGalleryForm from "./ServiceGalleryForm";
import ServiceDescFaq from "./ServiceDescFaq";
import PreviewPage from "./PreviewPage";
import { useCreateService } from "../../../../hooks/partnerHook/usePartnerService";
import { useSelector } from "react-redux";

const steps = [
  "Service Details",
  "Set Pricing",
  "Service Assets",
  // "Description & FAQ(optional)",
];

const ServiceForm = () => {
  const navigate = useNavigate();
  const { mutate: createServiceFN, isPending } = useCreateService(navigate);

  const userData = useSelector((state) => state.partner.user);
  const partnerId = userData?.partner?.id || null;

  const [currentStep, setCurrentStep] = useState(0);

  const [formData, setFormData] = useState({
    serviceTitle: "",
    category: "",
    subCategory: "",
    keywords: [],
    pricing: {
      half: { hours: "", price: "" },
      full: { hours: "", price: "" },
    },
    gallery: [],
    description: "",
    faqs: [],
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (isPending) return;

    const galleryData = formData.gallery || {
      mediaFiles: [],
      youtubeLink: [{ link: "" }],
    };
    const filteredMediaFiles = Array.isArray(galleryData.mediaFiles)
      ? galleryData.mediaFiles.filter((file) => file.url)
      : [];

    const formattedPayload = {
      ...formData,
      // subCategory: parseInt(formData.subCategory),
      subCategory:
        formData.subCategory && formData.subCategory.trim() !== ""
          ? parseInt(formData.subCategory)
          : "",
      keywords: formData.keywords.map((kw, index) => ({
        keyword_id: kw.keyword_id || index + 1,
        keyword: kw.keyword || kw,
      })),
      packages: Object.keys(formData.pricing).map((key) => ({
        package_name: key,
        ...formData.pricing[key],
      })),
      gallery: {
        mediaFiles: filteredMediaFiles,
        youtubeLink: galleryData.youtubeLink || [{ link: "" }],
      },
    };

    delete formattedPayload.pricing;

    console.log("Submitting Payload:", formattedPayload);

    await createServiceFN({ partnerId, formData: formattedPayload });
  };

  return (
    <div className={style.dashboardFormContainerWrapper}>
      <div className={style.dashboardFormContainer}>
        {currentStep === 0 ? (
          <>
            <h2 className={style.dashboardFormContinerHeading}>
              Add New Service
            </h2>
            <p className={style.noEquipmentDescription}>
              Add, edit, and manage the drone services you offer to potential
              clients.
            </p>
            <div className={style.verticalTimeline}>
              {steps.map((step, index) => (
                <div key={index} className={style.timelineStepWrapper}>
                  <div className={style.stepNumber}>{index + 1}</div>
                  {index < steps.length - 1 && (
                    <div className={style.verticalLine}></div>
                  )}
                  <div
                    className={style.timelineStep}
                    onClick={() => setCurrentStep(1)}
                  >
                    <div className={style.stepDetails}>
                      <p className={style.stepLabel}>Step {index + 1}</p>
                      <p className={style.stepTitle}>{step}</p>
                    </div>
                    <MdNavigateNext className={style.nextIcon} />
                  </div>
                </div>
              ))}
            </div>

            <div className={style.formButtonsContainer}>
              <button
                className={`${style.dashboardFormSaveButtonDown} ${style.disabledButton}`}
                type="button"
                disabled
              >
                Publish Service
              </button>
              <button className={style.serviceFormDraftButton} type="button">
                Save as Draft
              </button>
            </div>
          </>
        ) : currentStep === 1 ? (
          <ServiceDetailsForm
            formData={formData}
            setFormData={setFormData}
            handleNext={() => setCurrentStep(2)}
          />
        ) : currentStep === 2 ? (
          <ServicePackageForm
            formData={formData}
            setFormData={setFormData}
            handleNext={() => setCurrentStep(3)}
          />
        ) : currentStep === 3 ? (
          <ServiceGalleryForm
            formData={formData}
            setFormData={setFormData}
            handleNext={() => setCurrentStep(4)}
          />
        ) : (
          // ) : currentStep === 4 ? (
          //   <ServiceDescFaq
          //     formData={formData}
          //     setFormData={setFormData}
          //     handleInputChange={handleInputChange}
          //     handleNext={() => setCurrentStep(5)}
          //   />
          <PreviewPage
            formData={formData}
            setCurrentStep={setCurrentStep}
            handleSubmit={handleSubmit}
            isPending={isPending}
          />
        )}
      </div>
    </div>
  );
};

export default ServiceForm;
